import { Fragment, h } from 'preact';

import { Route } from 'libs/router';
import { routes } from 'features/fallback/routes';
import { Unhandled } from 'features/fallback/features/error/unhandled';
import { InvalidDevice } from 'features/fallback/features/error/invalid-device';
import { InvalidSession } from 'features/fallback/features/error/invalid-session';

export const FallbackError = () => {
    return (
        <Fragment>
            <Route path={routes.error.invalidSession} component={<InvalidSession/>}/>
            <Route path={routes.error.invalidDevice} component={<InvalidDevice/>}/>
            <Route path={routes.error.unhandled} component={<Unhandled/>}/>
        </Fragment>
    )
};
